import { render, staticRenderFns } from "./ModalImport.vue?vue&type=template&id=1be5b82e&"
import script from "./ModalImport.vue?vue&type=script&lang=js&"
export * from "./ModalImport.vue?vue&type=script&lang=js&"
import style0 from "./ModalImport.vue?vue&type=style&index=0&id=1be5b82e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports